import { put, call, select } from 'redux-saga/effects'
import { REQUEST_UPLOAD_TEMPLATE_START } from 'store/sagas'
import requestAddLayout from './requestAddLayout'
import sweetalert from 'sweetalert2'

export default function * requestAddLayoutTemplateFromFile (action) {
  const { file, ...payload } = action.payload

  const onUpload = function * ({ fileId }) {
    try {
      yield requestAddLayout({
        ...action,
        payload: {
          isTemplate: true,
          template: { type: 'file', id: fileId },
          ...payload
        }
      })
    } catch (e) {
      const state = yield select()
      try {
        yield call(sweetalert, {
          text: state.kanbo.locale.messages['DESK_ADD_NEW_TEMPLATE_FROM_FILE_ERROR'],
          type: 'error'
        })
      } catch (e) {} // eslint-disable-line no-empty
    }
  }

  yield put({
    type: REQUEST_UPLOAD_TEMPLATE_START,
    payload: {
      file,
      onUpload
    }
  })
}
